// extracted by mini-css-extract-plugin
export default {"details":"PageDataFormDetailList_details__GRlq0","details__add":"PageDataFormDetailList_details__add__92FBc","details__element":"PageDataFormDetailList_details__element__ky2wX"};